module.exports = __webpack_public_path__ + "8bd51de27d660ef6a0e1a4c6c8f0b32e.MP3";